/**
 * PTP Photo Library
 * Manages photo uploads, IndexedDB caching, and Vercel Blob storage
 */
(function() {
    var API_BASE = 'https://petposter.vercel.app/api/photo-library';
    var DB_NAME = 'ptp-photo-library';
    var DB_VERSION = 1;
    var STORE_NAME = 'photos';

    // Browser ID — persistent UUID per browser
    var browserId = localStorage.getItem('ptp-browser-id');
    if (!browserId) {
        browserId = 'b-' + Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('ptp-browser-id', browserId);
    }

    var linkedEmail = localStorage.getItem('ptp-linked-email') || '';
    var db = null;

    // ========== IndexedDB ==========

    function openDB() {
        return new Promise(function(resolve, reject) {
            var req = indexedDB.open(DB_NAME, DB_VERSION);
            req.onupgradeneeded = function(e) {
                var d = e.target.result;
                if (!d.objectStoreNames.contains(STORE_NAME)) {
                    d.createObjectStore(STORE_NAME, { keyPath: 'id' });
                }
            };
            req.onsuccess = function(e) { db = e.target.result; resolve(db); };
            req.onerror = function() { reject(req.error); };
        });
    }

    function idbSave(photo) {
        return new Promise(function(resolve, reject) {
            var tx = db.transaction(STORE_NAME, 'readwrite');
            tx.objectStore(STORE_NAME).put(photo);
            tx.oncomplete = function() { resolve(); };
            tx.onerror = function() { reject(tx.error); };
        });
    }

    function idbGetAll() {
        return new Promise(function(resolve, reject) {
            var tx = db.transaction(STORE_NAME, 'readonly');
            var req = tx.objectStore(STORE_NAME).getAll();
            req.onsuccess = function() { resolve(req.result || []); };
            req.onerror = function() { reject(req.error); };
        });
    }

    function idbDelete(id) {
        return new Promise(function(resolve, reject) {
            var tx = db.transaction(STORE_NAME, 'readwrite');
            tx.objectStore(STORE_NAME).delete(id);
            tx.oncomplete = function() { resolve(); };
            tx.onerror = function() { reject(tx.error); };
        });
    }

    // ========== UI ==========

    function renderGrid(photos) {
        var grid = document.getElementById('ptp-library-grid');
        if (!grid) return;

        if (!photos || photos.length === 0) {
            grid.innerHTML = '<div class="ptp-library-empty">' + (document.getElementById('ptp-library-panel')?.dataset.emptyText || 'No photos yet. Upload your first photo!') + '</div>';
            return;
        }

        // Sort newest first
        photos.sort(function(a, b) { return (b.uploadedAt || 0) - (a.uploadedAt || 0); });

        // Filter out entries with no usable image
        photos = photos.filter(function(p) { return p.thumbUrl || p.blobUrl || p.dataUrl; });
        if (photos.length === 0) {
            grid.innerHTML = '<div class="ptp-library-empty">' + (document.getElementById('ptp-library-panel')?.dataset.emptyText || 'No photos yet. Upload your first photo!') + '</div>';
            return;
        }

        grid.innerHTML = photos.map(function(p) {
            var date = new Date(p.uploadedAt);
            var ago = getTimeAgo(date);
            var imgSrc = p.thumbUrl || p.dataUrl || p.blobUrl;
            var fallback = p.dataUrl || p.blobUrl || '';
            return '<div class="ptp-library-item" data-id="' + p.id + '" data-url="' + (p.blobUrl || p.dataUrl || '') + '">' +
                '<img src="' + imgSrc + '" loading="lazy" onerror="if(this.src!==\'' + fallback.replace(/'/g, "\\'") + '\'){this.src=\'' + fallback.replace(/'/g, "\\'") + '\'}else{this.parentElement.style.display=\'none\'}">' +
                '<button class="ptp-library-item-delete" onclick="event.stopPropagation(); window.ptpDeletePhoto(\'' + p.id + '\', \'' + (p.blobUrl || '') + '\')">' +
                    '<svg viewBox="0 0 20 20"><line x1="4" y1="4" x2="16" y2="16"/><line x1="16" y1="4" x2="4" y2="16"/></svg>' +
                '</button>' +
                '<div class="ptp-library-item-date">' + ago + '</div>' +
            '</div>';
        }).join('');

        // Click to load into tool
        grid.querySelectorAll('.ptp-library-item').forEach(function(item) {
            item.addEventListener('click', function() {
                var url = this.getAttribute('data-url');
                var id = this.getAttribute('data-id');
                if (url) {
                    loadPhotoIntoTool(url);
                    // Mark this photo as most recently selected so it restores on next page load
                    if (id && db) {
                        var tx = db.transaction(STORE_NAME, 'readwrite');
                        var store = tx.objectStore(STORE_NAME);
                        var req = store.get(id);
                        req.onsuccess = function() {
                            if (req.result) {
                                req.result.uploadedAt = Date.now();
                                store.put(req.result);
                            }
                        };
                    }
                }
            });
        });
    }

    function getTimeAgo(date) {
        var diff = Date.now() - date.getTime();
        var mins = Math.floor(diff / 60000);
        if (mins < 60) return mins + 'm ago';
        var hours = Math.floor(mins / 60);
        if (hours < 24) return hours + 'h ago';
        var days = Math.floor(hours / 24);
        return days + 'd ago';
    }

    function loadPhotoIntoTool(url) {
        // Close panel
        var panel = document.getElementById('ptp-library-panel');
        if (panel) panel.classList.remove('active');

        // Pet Poster mode: use the pet poster callback if available
        if (window.ppLoadPetPhotoFromLibrary) {
            window.ppLoadPetPhotoFromLibrary(url);
            return;
        }

        // Photo Poster mode: load into the poster tool
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onerror = function() {
            console.warn('[PTP Library] Failed to load image:', url.substring(0, 80));
            $('.product-form__submit[name="add"]').attr('disabled', false);
        };
        img.onload = function() {
            var objectURL = url;

            $('.bp-illustration-img').attr('src', objectURL);
            $('.bp-illustration-filter-img').attr('src', objectURL);
            $('.bp-upload-overlay').addClass('hide');

            // Store as canvas for filtering
            var c = document.createElement('canvas');
            c.width = img.width;
            c.height = img.height;
            c.getContext('2d').drawImage(img, 0, 0);

            // Access the ptpOriginalCanvas from the input handler scope
            // We'll use a global setter
            if (window.ptpSetOriginalCanvas) {
                window.ptpSetOriginalCanvas(c, img.width, img.height);
            }

            // Generate filter thumbnails
            if (window.ptpFilterEngine) {
                window.ptpFilterEngine.generateThumbnails(img, function(filterId, dataUrl) {
                    var preview = document.querySelector('.ptp-filter-preview[data-filter-id="' + filterId + '"]');
                    if (preview) preview.style.backgroundImage = 'url(' + dataUrl + ')';
                });
            }

            // Set cropped photo input for cart submission
            var canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            canvas.getContext('2d').drawImage(img, 0, 0);
            canvas.toBlob(function(blob) {
                if (blob) {
                    var file = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
                    var dt = new DataTransfer();
                    dt.items.add(file);
                    var croppedInput = document.getElementById('cropped_photo');
                    if (croppedInput) croppedInput.files = dt.files;
                    window.ptpUploadedFile = file;
                }
            }, 'image/jpeg', 0.9);

            // Enable add to cart
            $('.product-form__submit[name="add"]').attr('disabled', false);
            $('.bp-save-for-later-btn').removeClass('hide');
            $('.bp-frame-radio:checked').change();

            // Restore saved filter + strength
            var savedFilter = localStorage.getItem('ptp-selected-filter');
            var savedStrength = localStorage.getItem('ptp-filter-strength');
            if (savedFilter && savedFilter !== 'original') {
                setTimeout(function() {
                    $('.ptp-filter-radio[value="' + savedFilter + '"]').prop('checked', true).trigger('change');
                    if (savedStrength) {
                        $('.ptp-filter-range').val(savedStrength).trigger('input');
                    }
                }, 500); // delay to let thumbnails generate first
            }
        };
        img.src = url;
    }

    // ========== API ==========

    async function uploadToBlob(file) {
        // Convert to base64
        var dataUrl = await new Promise(function(resolve) {
            var reader = new FileReader();
            reader.onload = function() { resolve(reader.result); };
            reader.readAsDataURL(file);
        });

        var resp = await fetch(API_BASE + '/upload', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ image: dataUrl, browserId: browserId })
        });

        if (!resp.ok) throw new Error('Upload failed');
        return await resp.json();
    }

    async function loadFromBlob() {
        var params = 'browserId=' + encodeURIComponent(browserId);
        if (linkedEmail) params += '&email=' + encodeURIComponent(linkedEmail);

        var resp = await fetch(API_BASE + '/list?' + params);
        if (!resp.ok) return [];
        var data = await resp.json();
        return data.photos || [];
    }

    // ========== Public API ==========

    // Save a base64 photo to the library (called from external tools)
    window.ptpSaveToLibrary = async function(dataUrl) {
        if (!dataUrl || !dataUrl.startsWith('data:')) return;
        var id = 'pet-' + Date.now();
        var thumbUrl = await generateThumbnail(dataUrl);
        var entry = { id: id, dataUrl: dataUrl, thumbUrl: thumbUrl, blobUrl: null, uploadedAt: Date.now() };
        try { await idbSave(entry); } catch(e) {}
        // Upload to blob in background
        try {
            var resp = await fetch(API_BASE + '/upload', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ image: dataUrl, browserId: browserId })
            });
            if (resp.ok) {
                var data = await resp.json();
                if (data.url) { entry.blobUrl = data.url; try { await idbSave(entry); } catch(e) {} }
            }
        } catch(e) {}
    };

    // Belt-and-suspenders: bind close-on-overlay-click via JS in case the inline
    // onclick attribute on .ptp-library-overlay doesn't fire (some mobile
    // browsers / event listeners interfere).
    function closeLibraryAndClearTarget() {
        var panel = document.getElementById('ptp-library-panel');
        if (panel && panel.classList.contains('active')) {
            panel.classList.remove('active');
        }
        // Stale target would affect the NEXT photo pick — clear it.
        window.ppDuoTarget = null;
    }

    // Robust close-on-outside-click: any click that lands outside the actual
    // drawer content (.ptp-library-content) dismisses the library. Works
    // regardless of CSS pointer-events state on the panel/overlay (Shopify's
    // compile-cache made the CSS-only approach unreliable on mobile).
    document.addEventListener('click', function(e) {
        var panel = document.getElementById('ptp-library-panel');
        if (!panel || !panel.classList.contains('active')) return;
        // Click on a toggle button → let its own handler manage state
        if (e.target.closest('[onclick*="ptpToggleLibrary"]')) return;
        // Click inside the actual drawer content → keep open
        if (e.target.closest('.ptp-library-content')) return;
        closeLibraryAndClearTarget();
    });

    // HEADING/SUBHEADING URL PARAM SYNC — bypasses Shopify section-cache.
    // The per-aquarelle redirect snippet sends `?heading=TEDDY&subheading=
    // GOLDEN+RETRIEVER` etc. The customizer's HTML inline script reads these,
    // but it's stuck behind the section-cache. Re-implement here in JS so it
    // works as soon as this asset loads.
    //
    // Edit-mode behaviour: when `?edit_token=` is in the URL (customer clicked
    // their post-purchase edit link), URL params represent server-side truth
    // and must OVERWRITE whatever localStorage form-restore put in the inputs.
    // Otherwise we leak stale design data from a previous session.
    (function syncHeadingFromUrl() {
        function apply() {
            var params = new URLSearchParams(window.location.search);
            var heading = params.get('heading');
            var subheading = params.get('subheading');
            var dateParam = params.get('date'); // DD-MM-YYYY (matches stored properties[__Date])
            var force = !!params.get('edit_token'); // edit-mode → force overwrite
            if (heading) {
                var ni = document.querySelector('.bp-name-input');
                if (ni && (force || !ni.value)) {
                    ni.value = heading;
                    if (window.jQuery) window.jQuery(ni).trigger('input');
                    else ni.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
            if (subheading != null) {
                // The Subheading line-item property is "BREED / DD MONTH YYYY"
                // (joined for the cart property). The customizer renders breed
                // and date as separate spans, so the breed input must get ONLY
                // the breed part. Two shapes:
                //   "BREED / DATE" → take the part before the first " / ".
                //   date-only (no breed) → empty breed (else the date is dumped
                //   into the breed field AND duplicated into the saved subheading).
                var breedOnly;
                if (subheading.indexOf('/') !== -1) {
                    breedOnly = subheading.split(/\s*\/\s*/)[0].trim();
                } else if (/\d{4}/.test(subheading) && /(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i.test(subheading)) {
                    breedOnly = ''; // looks like a date-only subheading → no breed
                } else {
                    breedOnly = subheading.trim();
                }
                var bi = document.querySelector('.bp-breed-input');
                if (bi && (force || !bi.value)) {
                    bi.value = breedOnly;
                    if (window.jQuery) window.jQuery(bi).trigger('input');
                    else bi.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
            if (dateParam) {
                // The date arrives as DD-MM-YYYY, the same format the customizer
                // stores in properties[__Date]. Force the hidden field + the
                // visible day/month/year selectors so the order's date wins over
                // any restored session.
                var di = document.querySelector('#pet-date-1');
                if (di && (force || !di.value)) {
                    var parts = dateParam.split('-'); // [DD, MM, YYYY]
                    try { localStorage.setItem('properties[__Date]', dateParam); } catch (e) {}
                    di.value = dateParam;
                    if (parts.length === 3 && window.jQuery) {
                        var $ = window.jQuery;
                        var months = ['january','february','march','april','may','june','july','august','september','october','november','december'];
                        var monthName = months[parseInt(parts[1], 10) - 1];
                        var $month = $('#bp-month-selector-1');
                        // Only drive the selectors if the month option exists (the
                        // selector is missing January in some locales — don't let a
                        // failed .val() corrupt the date via the change-combine).
                        if (monthName && $month.find('option[value="' + monthName + '"]').length) {
                            $month.val(monthName);
                            $('#bp-day-selector-1').val(String(parseInt(parts[0], 10)));
                            $('#bp-year-selector-1').val(parts[2]);
                            $month.trigger('change');
                        }
                    }
                    if (window.jQuery) window.jQuery(di).trigger('change');
                    else di.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }
        // Run both ASAP (in case DOM is ready) and after DOMContentLoaded.
        // Also retry after delay in case other JS init (localStorage restore,
        // etc.) clobbers inputs. In edit-mode we re-force on every retry so
        // we always end up with server values.
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', apply);
        } else {
            apply();
        }
        setTimeout(apply, 500);
        setTimeout(apply, 1500);
        setTimeout(apply, 3000);
    })();

    // ──────────────────────────────────────────────────────────────────────
    // NO-SUBHEADING PERSISTENCE — remember the customer's "no second line"
    // choice across product navigation. Without persistence, every new
    // product page resets the checkbox and the customer has to tick it
    // again. Stored in localStorage so it travels per device.
    // ──────────────────────────────────────────────────────────────────────
    (function persistNoHeading() {
        var KEY = 'pp.noHeading';
        function apply() {
            var saved = null;
            try { saved = localStorage.getItem(KEY); } catch(e) {}
            if (saved !== '1') return;
            var cb = document.getElementById('bp-no-heading-checkbox-1');
            if (!cb) return;
            cb.checked = true;
            if (window.jQuery) window.jQuery(cb).trigger('change');
            else cb.dispatchEvent(new Event('change', { bubbles: true }));
        }
        function bindSave() {
            var cb = document.getElementById('bp-no-heading-checkbox-1');
            if (!cb || cb.__pp_save_bound) return;
            cb.__pp_save_bound = true;
            cb.addEventListener('change', function() {
                try { localStorage.setItem(KEY, cb.checked ? '1' : '0'); } catch(e) {}
            });
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() { apply(); bindSave(); });
        } else { apply(); bindSave(); }
        setTimeout(function() { apply(); bindSave(); }, 500);
        setTimeout(function() { apply(); bindSave(); }, 1500);
    })();

    (function persistNoSubheading() {
        var KEY = 'pp.noSubheading';
        function apply() {
            var saved = null;
            try { saved = localStorage.getItem(KEY); } catch(e) {}
            if (saved !== '1') return;
            var cb = document.getElementById('bp-no-subheading-checkbox-1');
            if (!cb) return;
            cb.checked = true;
            // Always fire change — inline section handler may have been
            // bound after our first call. Handler is idempotent (caches
            // savedHTML only on the first invocation, dim/disable are no-ops
            // when already applied). It also sets the hidden flag to 'true'
            // so the form submission reads it correctly.
            if (window.jQuery) window.jQuery(cb).trigger('change');
            else cb.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Listen for checkbox changes and persist the new state
        function bindSave() {
            var cb = document.getElementById('bp-no-subheading-checkbox-1');
            if (!cb || cb.__pp_save_bound) return;
            cb.__pp_save_bound = true;
            cb.addEventListener('change', function() {
                try { localStorage.setItem(KEY, cb.checked ? '1' : '0'); } catch(e) {}
            });
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() { apply(); bindSave(); });
        } else { apply(); bindSave(); }
        // Retry — other JS may build the checkbox / set state later
        setTimeout(function() { apply(); bindSave(); }, 500);
        setTimeout(function() { apply(); bindSave(); }, 1500);
    })();

    // ──────────────────────────────────────────────────────────────────────
    // ADD-TO-CART INTERCEPTION — "did you customize the name?" modal.
    //
    // Customers often forget to change the placeholder heading (TEDDY, MILA,
    // etc.) and the breed default before checkout. That's how orders #1019–
    // #1022 came in with WILD GARDEN / MILA / etc. instead of their real pet's
    // name. We intercept the add-to-cart click, check if the inputs still
    // match a slot default, and prompt them to confirm or edit.
    // ──────────────────────────────────────────────────────────────────────
    (function petNameGuard() {
        var DEFAULT_NAMES = ['TEDDY','SCOUT','MILO','MILA','OSCAR','REX','SHADOW','LEO','KODA','DUCHESS','WILD GARDEN','VILD TRÄDGÅRD'];
        // All localized breed values (12 locales × 10 breeds). If the breed
        // input value is in this set, it hasn't been customized.
        var DEFAULT_BREEDS = [
            // GOLDEN RETRIEVER
            'GOLDEN RETRIEVER','ZLATÝ RETRÍVR','ゴールデン・レトリバー',
            // BORDER COLLIE
            'BORDER COLLIE','BORDER KOLIE','ボーダー・コリー',
            // CAVALIER
            'CAVALIER','KAVALÍR','キャバリア',
            // TABBY CAT
            'TABBY CAT','MOUROVATÁ KOČKA','TABBY KAT','TABBY KATZE','GATO ATIGRADO',
            'CHAT TIGRÉ','TÍGURKETTA','GATTO SORIANO','キジトラ猫','TABBY KATT',
            'CYPERSE KAT','KOT PRĘGOWANY','TABBYKATT','BONDKATT',
            // DACHSHUND
            'DACHSHUND','JEZEVČÍK','GRAVHUND','DACKEL','TECKEL','BASSOTTO',
            'ダックスフンド','JAMNIK','TAX',
            // DOBERMAN
            'DOBERMAN','DOBRMAN','DOBERMANN','DÓBERMAN','ドーベルマン',
            // BLACK CAT
            'BLACK CAT','ČERNÁ KOČKA','SORT KAT','SCHWARZE KATZE','GATO NEGRO',
            'CHAT NOIR','SVARTUR KÖTTUR','GATTO NERO','黒猫','SVART KATT',
            'ZWARTE KAT','CZARNY KOT',
            // MAINE COON
            'MAINE COON','メインクーン',
            // HUSKY
            'HUSKY','ハスキー',
            // PERSIAN CAT
            'PERSIAN CAT','PERSKÁ KOČKA','PERSISK KAT','PERSERKATZE','GATO PERSA',
            'CHAT PERSAN','PERSAKÖTTUR','GATTO PERSIANO','ペルシャ猫','PERSISK KATT',
            'PERZISCHE KAT','KOT PERSKI','PERSER',
        ];

        // Locale-aware modal strings. Falls back to English.
        var T = {
            en: { title:'Wait — did you customize the name?', body:'Looks like you haven\'t changed the pet name yet — your poster will say "<b>{H}</b> / <b>{S}</b>". Is that what you want?', edit:'✏ Edit name', cont:'✓ Yes, continue' },
            cs: { title:'Moment — upravili jste jméno?', body:'Vypadá to, že jste ještě nezměnili jméno mazlíčka — váš plakát bude obsahovat „<b>{H}</b> / <b>{S}</b>". Je to tak v pořádku?', edit:'✏ Upravit jméno', cont:'✓ Ano, pokračovat' },
            da: { title:'Vent — har du tilpasset navnet?', body:'Det ser ud til, at du ikke har ændret kæledyrets navn endnu — din plakat vil vise "<b>{H}</b> / <b>{S}</b>". Er det det, du vil?', edit:'✏ Rediger navn', cont:'✓ Ja, fortsæt' },
            de: { title:'Moment — haben Sie den Namen angepasst?', body:'Es sieht so aus, als hätten Sie den Namen des Haustiers noch nicht geändert — auf Ihrem Poster steht "<b>{H}</b> / <b>{S}</b>". Ist das gewollt?', edit:'✏ Name bearbeiten', cont:'✓ Ja, weiter' },
            es: { title:'Espera — ¿personalizaste el nombre?', body:'Parece que aún no cambiaste el nombre de tu mascota — tu póster dirá "<b>{H}</b> / <b>{S}</b>". ¿Es lo que quieres?', edit:'✏ Editar nombre', cont:'✓ Sí, continuar' },
            fr: { title:'Attendez — avez-vous personnalisé le nom ?', body:'Il semble que vous n\'ayez pas encore modifié le nom de l\'animal — votre affiche affichera « <b>{H}</b> / <b>{S}</b> ». Est-ce bien ce que vous voulez ?', edit:'✏ Modifier le nom', cont:'✓ Oui, continuer' },
            is: { title:'Bíddu — breyttirðu nafninu?', body:'Það lítur út fyrir að þú hafir ekki breytt nafni gæludýrsins enn — plakatið þitt mun segja "<b>{H}</b> / <b>{S}</b>". Er það það sem þú vilt?', edit:'✏ Breyta nafni', cont:'✓ Já, halda áfram' },
            it: { title:'Aspetta — hai personalizzato il nome?', body:'Sembra che tu non abbia ancora cambiato il nome del tuo animale — il tuo poster mostrerà "<b>{H}</b> / <b>{S}</b>". È ciò che vuoi?', edit:'✏ Modifica nome', cont:'✓ Sì, continua' },
            ja: { title:'ちょっと待って — 名前をカスタマイズしましたか？', body:'まだペットの名前を変更していないようです — ポスターには「<b>{H}</b> / <b>{S}</b>」と表示されます。これでよろしいですか？', edit:'✏ 名前を編集', cont:'✓ はい、続ける' },
            nb: { title:'Vent — tilpasset du navnet?', body:'Det ser ut til at du ikke har endret kjæledyrets navn ennå — plakaten din vil vise "<b>{H}</b> / <b>{S}</b>". Er det det du vil?', edit:'✏ Rediger navn', cont:'✓ Ja, fortsett' },
            nl: { title:'Wacht — heb je de naam aangepast?', body:'Het lijkt erop dat je de naam van je huisdier nog niet hebt aangepast — op je poster komt "<b>{H}</b> / <b>{S}</b>" te staan. Is dat wat je wilt?', edit:'✏ Naam bewerken', cont:'✓ Ja, ga door' },
            pl: { title:'Chwila — czy zmieniłeś imię?', body:'Wygląda na to, że jeszcze nie zmieniłeś imienia swojego pupila — Twój plakat będzie miał napis „<b>{H}</b> / <b>{S}</b>". Czy o to chodzi?', edit:'✏ Edytuj imię', cont:'✓ Tak, kontynuuj' },
            sv: { title:'Vänta — anpassade du namnet?', body:'Det ser ut som att du inte har ändrat husdjurets namn än — din affisch kommer att visa "<b>{H}</b> / <b>{S}</b>". Är det vad du vill?', edit:'✏ Redigera namn', cont:'✓ Ja, fortsätt' },
        };

        function lang() {
            var l = (document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'en').split('-')[0].toLowerCase();
            return T[l] ? l : 'en';
        }

        function bypassed() {
            // Once user confirms "continue", set a flag so the next click goes through.
            return window.__pp_name_guard_bypass === true;
        }

        function inputDefault(value, list) {
            var v = (value || '').trim().toUpperCase();
            return v && list.indexOf(v) !== -1;
        }

        // Track whether the customer has actually interacted with each input. If
        // they have (typed, pasted, restored from saved design), we trust the
        // value even if it happens to match a default-list entry — a customer
        // whose pet is genuinely named "Bella" or "Dachshund" shouldn't be
        // pestered with a "did you change the name?" modal.
        function userEdited(el) {
            return !!(el && el.dataset && el.dataset.userEdited === '1');
        }
        function markEdited(e) {
            if (e && e.target && e.target.dataset) e.target.dataset.userEdited = '1';
        }
        document.addEventListener('input',  function(e) {
            if (e.target && (e.target.classList.contains('bp-name-input') || e.target.classList.contains('bp-breed-input') || e.target.classList.contains('bp-custom-text'))) markEdited(e);
        }, true);
        document.addEventListener('change', function(e) {
            if (e.target && (e.target.classList.contains('bp-name-input') || e.target.classList.contains('bp-breed-input') || e.target.classList.contains('bp-custom-text'))) markEdited(e);
        }, true);

        function effectiveSubheadingMode() {
            // Returns 'none' if "No subheading" is on, 'custom' if custom-text mode is on with a value,
            // or 'breed' (default) — only in 'breed' mode does the breed input affect the printed poster.
            var noSub = ((document.getElementById('bp-no-subheading-1') || {}).value || '').trim() === 'true';
            if (noSub) return 'none';
            var ctFlag = ((document.getElementById('bp-custom-text-flag-1') || {}).value || '').trim() === 'true';
            var ctVal = ((document.getElementById('bp-custom-text-1') || {}).value || '').trim();
            if (ctFlag && ctVal) return 'custom';
            return 'breed';
        }
        function noHeadingOn() {
            return ((document.getElementById('bp-no-heading-1') || {}).value || '').trim() === 'true';
        }
        function shouldGuard() {
            // Heading is only printed if the "No heading" toggle is OFF — otherwise
            // its default-value-ness is irrelevant. Skip if the user has actually
            // edited the input (typed / restored from saved design) — their value
            // is intentional even if it happens to match a default-list entry.
            if (!noHeadingOn()) {
                var nameEl = document.querySelector('.bp-name-input');
                if (nameEl && !userEdited(nameEl) && inputDefault(nameEl.value, DEFAULT_NAMES)) return true;
            }
            // Breed only matters when it'll actually be printed (no-subheading OFF AND no custom text)
            if (effectiveSubheadingMode() !== 'breed') return false;
            var breedEl = document.querySelector('.bp-breed-input');
            if (breedEl && !userEdited(breedEl) && inputDefault(breedEl.value, DEFAULT_BREEDS)) return true;
            return false;
        }

        function buildModal() {
            if (document.getElementById('pp-name-guard-bg')) return;
            // Two SEPARATE body-level elements (not nested) — keeps the
            // backdrop-filter in the page's stacking context so it can blur
            // the actual page behind it. Use explicit pixels + !important
            // inline to beat any external CSS clamping.
            var w = window.innerWidth, h = window.innerHeight;
            var bg = document.createElement('div');
            bg.id = 'pp-name-guard-bg';
            var set = function(el, k, v) { el.style.setProperty(k, v, 'important'); };
            set(bg,'position','fixed');set(bg,'top','0');set(bg,'left','0');
            set(bg,'width', w + 'px');set(bg,'height', h + 'px');
            set(bg,'min-width', w + 'px');set(bg,'min-height', h + 'px');
            set(bg,'z-index','100000');set(bg,'display','none');
            set(bg,'background','rgba(0,0,0,0.35)');
            set(bg,'backdrop-filter','blur(20px) saturate(150%)');
            set(bg,'-webkit-backdrop-filter','blur(20px) saturate(150%)');
            set(bg,'cursor','pointer');set(bg,'contain','none');
            bg.addEventListener('click', hide);
            document.body.appendChild(bg);

            var card = document.createElement('div');
            card.id = 'pp-name-guard-card';
            set(card,'position','fixed');set(card,'top','50%');set(card,'left','50%');
            set(card,'transform','translate(-50%,-50%)');
            set(card,'z-index','100001');set(card,'display','none');
            set(card,'background','#fff');set(card,'max-width','420px');
            set(card,'width','calc(100vw - 48px)');
            set(card,'border-radius','12px');set(card,'padding','28px');
            set(card,'box-shadow','0 20px 60px rgba(0,0,0,0.35)');
            set(card,'text-align','center');
            set(card,'font-family','Helvetica,Arial,sans-serif');
            card.innerHTML =
                '<h2 id="pp-name-guard-title" style="margin:0 0 12px;font-size:18px;font-weight:600;color:#1a1a1a;line-height:1.35"></h2>' +
                '<p id="pp-name-guard-body" style="margin:0 0 20px;font-size:14px;line-height:1.55;color:#555"></p>' +
                '<div style="display:flex;flex-direction:column;gap:8px">' +
                '  <button id="pp-name-guard-edit" style="background:#1a1a1a;color:#fff;border:none;padding:13px 20px;border-radius:8px;font-weight:600;font-size:14px;cursor:pointer;letter-spacing:.4px"></button>' +
                '  <button id="pp-name-guard-cont" style="background:transparent;color:#888;border:none;padding:10px;font-size:13px;cursor:pointer"></button>' +
                '</div>';
            document.body.appendChild(card);
            // wrap is gone — directly query the buttons via id
            var wrap = { querySelector: function(sel) { return document.querySelector(sel); } };
            wrap.querySelector('#pp-name-guard-edit').addEventListener('click', function() {
                hide();
                // 1. Switch to the PET INFO tab (bp-sidebar-item-2 — that's
                //    the one containing the .bp-name-input + .bp-breed-input).
                var infoLabel = document.querySelector('label[for="bp-sidebar-item-2"]');
                var infoRadio = document.getElementById('bp-sidebar-item-2');
                if (infoLabel) infoLabel.click();
                else if (infoRadio) infoRadio.checked = true;
                document.querySelectorAll('.bp-sidebar-nav-item').forEach(function(el) {
                    el.classList.toggle('active', el.getAttribute('for') === 'bp-sidebar-item-2');
                });
                // 2. Focus the name input + scroll to it
                setTimeout(function() {
                    var ni = document.querySelector('.bp-name-input');
                    if (ni) {
                        ni.focus();
                        ni.select && ni.select();
                        ni.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);
            });
            wrap.querySelector('#pp-name-guard-cont').addEventListener('click', function() {
                hide();
                // Allow next click through without intercept
                window.__pp_name_guard_bypass = true;
                // Re-trigger the cart-add click on the actual submit button
                var btn = document.querySelector('.bp-buy-btn .product-form__submit');
                if (btn) setTimeout(function() { btn.click(); }, 50);
            });
        }
        function hide() {
            var bg = document.getElementById('pp-name-guard-bg');
            var card = document.getElementById('pp-name-guard-card');
            if (bg) bg.style.setProperty('display','none','important');
            if (card) card.style.setProperty('display','none','important');
        }
        function show() {
            buildModal();
            var strings = T[lang()] || T.en;
            var heading = (document.querySelector('.bp-name-input') || {}).value || '';
            var breed = (document.querySelector('.bp-breed-input') || {}).value || '';
            var esc = function(s){ return (s+'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
            var mode = effectiveSubheadingMode();
            var body;
            if (mode !== 'breed') {
                // Subheading won't include the breed — drop the "/ {S}" portion
                body = strings.body.replace(/\s*\/\s*[«"„"「]?<b>\{S\}<\/b>[»"」"]?/, '').replace('{H}', esc(heading));
            } else {
                body = strings.body.replace('{H}', esc(heading)).replace('{S}', esc(breed));
            }
            document.getElementById('pp-name-guard-title').textContent = strings.title;
            document.getElementById('pp-name-guard-body').innerHTML = body;
            document.getElementById('pp-name-guard-edit').textContent = strings.edit;
            document.getElementById('pp-name-guard-cont').textContent = strings.cont;
            var bg = document.getElementById('pp-name-guard-bg');
            var card = document.getElementById('pp-name-guard-card');
            // Re-size backdrop to current viewport (orientation/resize-safe)
            var w = window.innerWidth, h = window.innerHeight;
            bg.style.setProperty('width', w + 'px', 'important');
            bg.style.setProperty('height', h + 'px', 'important');
            bg.style.setProperty('display','block','important');
            card.style.setProperty('display','block','important');
        }

        // Capture-phase listener — runs before any other click handler.
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('.bp-buy-btn .product-form__submit');
            if (!btn) return;
            if (bypassed()) return;
            if (!shouldGuard()) return;
            e.preventDefault();
            e.stopPropagation();
            show();
        }, true);
    })();

    // INLINE CSS INJECTION — bypasses Shopify section-cache.
    // The standalone `ptp-library-fix.css` file we added to the section liquid
    // takes 1+ hour to propagate (section cache). To skip that wait, we inject
    // the exact same rules as a <style> block here. Runs as soon as this JS
    // file loads — fresh JS = fresh styles.
    (function injectLibraryFix() {
        if (document.getElementById('ptp-library-fix-style')) return;
        var s = document.createElement('style');
        s.id = 'ptp-library-fix-style';
        s.textContent = [
          /* Drawer panel above everything including header */
          '.ptp-library-panel{position:fixed!important;inset:0!important;z-index:99999!important;pointer-events:none!important;visibility:hidden!important;opacity:1!important;transition:visibility .3s!important}',
          '.ptp-library-panel.active{visibility:visible!important}',
          '.ptp-library-panel.active .ptp-library-content{pointer-events:auto!important}',
          /* Blurred backdrop one z-step below the panel but above the page */
          '.ptp-library-overlay{position:fixed!important;inset:0!important;z-index:99998!important;background:rgba(0,0,0,.22)!important;backdrop-filter:blur(16px) saturate(140%)!important;-webkit-backdrop-filter:blur(16px) saturate(140%)!important;pointer-events:none!important}',
          '.ptp-library-overlay.is-open{pointer-events:auto!important}',
        ].join('\n');
        (document.head || document.documentElement).appendChild(s);
    })();

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeLibraryAndClearTarget();
    });

    // The existing .ptp-library-overlay element gets sized 0x0 by some cached
    // CSS rule we can't override (likely a `width: 0` or `display: contents`
    // from the minified photoposter.css). Bypass entirely by creating a
    // brand-new backdrop div with all styles set as inline `!important` —
    // that beats every external CSS rule, regardless of cache state.
    function hoistOverlay() {
        // Hide the broken original overlay if present, then provide our own.
        var oldOverlay = document.querySelector('.ptp-library-overlay');
        if (oldOverlay) oldOverlay.style.setProperty('display', 'none', 'important');

        var bd = document.getElementById('ptp-blur-backdrop');
        if (!bd) {
            bd = document.createElement('div');
            bd.id = 'ptp-blur-backdrop';
            bd.className = 'ptp-library-overlay'; // keep class so JS lookups still work
            bd.addEventListener('click', closeLibraryAndClearTarget);
            document.body.appendChild(bd);
        }
        // Apply size + position EVERY time so a window resize / orientation
        // change re-sizes the backdrop. Use explicit pixel values (vw/vh
        // failed to resolve on this page — some ancestor is constraining
        // viewport units). Cover all the bases with !important inline.
        var w = window.innerWidth;
        var h = window.innerHeight;
        bd.style.setProperty('position', 'fixed', 'important');
        bd.style.setProperty('display', 'block', 'important');
        bd.style.setProperty('top', '0px', 'important');
        bd.style.setProperty('left', '0px', 'important');
        bd.style.setProperty('right', '0px', 'important');
        bd.style.setProperty('bottom', '0px', 'important');
        bd.style.setProperty('width', w + 'px', 'important');
        bd.style.setProperty('height', h + 'px', 'important');
        bd.style.setProperty('min-width', w + 'px', 'important');
        bd.style.setProperty('min-height', h + 'px', 'important');
        bd.style.setProperty('max-width', 'none', 'important');
        bd.style.setProperty('max-height', 'none', 'important');
        bd.style.setProperty('margin', '0', 'important');
        bd.style.setProperty('padding', '0', 'important');
        bd.style.setProperty('box-sizing', 'border-box', 'important');
        bd.style.setProperty('contain', 'none', 'important');
        bd.style.setProperty('visibility', 'visible', 'important');
        bd.style.setProperty('z-index', '99998', 'important');
        bd.style.setProperty('background', 'rgba(0,0,0,0.22)', 'important');
        bd.style.setProperty('backdrop-filter', 'blur(16px) saturate(140%)', 'important');
        bd.style.setProperty('-webkit-backdrop-filter', 'blur(16px) saturate(140%)', 'important');
        bd.style.setProperty('transition', 'opacity 0.3s ease', 'important');
        return bd;
    }

    // Toggle opacity + pointer-events on the new backdrop when .is-open class
    // changes. (.is-open class is what JS adds when panel opens — our backdrop
    // uses the same convention so other code paths still work.)
    function syncBackdrop(open) {
        var bd = document.getElementById('ptp-blur-backdrop');
        if (!bd) return;
        if (open) {
            bd.style.setProperty('opacity', '1', 'important');
            bd.style.setProperty('pointer-events', 'auto', 'important');
            bd.classList.add('is-open');
        } else {
            bd.style.setProperty('opacity', '0', 'important');
            bd.style.setProperty('pointer-events', 'none', 'important');
            bd.classList.remove('is-open');
        }
    }

    // Also force the panel z-index so the drawer paints above any header.
    function forcePanelStyle() {
        var panel = document.getElementById('ptp-library-panel');
        if (!panel) return;
        panel.style.setProperty('z-index', '99999', 'important');
        panel.style.setProperty('position', 'fixed', 'important');
        panel.style.setProperty('top', '0', 'important');
        panel.style.setProperty('right', '0', 'important');
        panel.style.setProperty('bottom', '0', 'important');
        panel.style.setProperty('left', '0', 'important');
        panel.style.setProperty('opacity', '1', 'important'); // no stacking-context-via-opacity
        panel.style.setProperty('pointer-events', 'none', 'important');
        var content = panel.querySelector('.ptp-library-content');
        if (content) content.style.setProperty('pointer-events', 'auto', 'important');
    }

    window.ptpToggleLibrary = function() {
        var panel = document.getElementById('ptp-library-panel');
        if (!panel) return;
        hoistOverlay();
        forcePanelStyle();
        panel.classList.toggle('active');
        var open = panel.classList.contains('active');
        syncBackdrop(open);
        // Lock background scroll so the page underneath doesn't move on mobile
        document.body.classList.toggle('pp-library-open', open);
        document.documentElement.classList.toggle('pp-library-open', open);
        if (open) refreshLibrary();
    };
    // Reconcile overlay/body state whenever the panel's class is toggled by
    // other means (overlay click, Escape, swipe-right).
    var _libObserver = new MutationObserver(function () {
        var p = document.getElementById('ptp-library-panel');
        if (!p) return;
        var open = p.classList.contains('active');
        syncBackdrop(open);
        document.body.classList.toggle('pp-library-open', open);
        document.documentElement.classList.toggle('pp-library-open', open);
    });
    document.addEventListener('DOMContentLoaded', function () {
        hoistOverlay();
        var p = document.getElementById('ptp-library-panel');
        if (p) _libObserver.observe(p, { attributes: true, attributeFilter: ['class'] });
    });

    // Swipe-right-to-close gesture (mobile). Panel slides in from the right,
    // so dragging the content rightward dismisses it. Vertical scrolling is
    // preserved — gesture only triggers when motion is mostly horizontal.
    (function bindSwipeToClose() {
        var panel = document.getElementById('ptp-library-panel');
        if (!panel) return;
        var content = panel.querySelector('.ptp-library-content');
        if (!content) return;

        var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false, decided = false;
        var SWIPE_DECIDE_PX = 8;        // movement before we decide horizontal vs vertical
        var CLOSE_RATIO = 0.25;          // dismiss if dragged > 25% of panel width
        var CLOSE_VELOCITY = 0.4;        // dismiss if velocity > 0.4 px/ms (flick)
        var startTs = 0;

        content.addEventListener('touchstart', function (e) {
            if (!panel.classList.contains('active')) return;
            // Don't start a swipe on interactive controls (allow normal tapping)
            if (e.target.closest('button, input, textarea, a, [role=button]')) return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            startTs = Date.now();
            dx = 0; dy = 0; dragging = true; decided = false;
            content.style.transition = 'none';
        }, { passive: true });

        content.addEventListener('touchmove', function (e) {
            if (!dragging) return;
            dx = e.touches[0].clientX - startX;
            dy = e.touches[0].clientY - startY;
            if (!decided && (Math.abs(dx) > SWIPE_DECIDE_PX || Math.abs(dy) > SWIPE_DECIDE_PX)) {
                decided = true;
                // Vertical motion → user is scrolling; abandon swipe
                if (Math.abs(dy) > Math.abs(dx)) {
                    dragging = false;
                    content.style.transition = '';
                    return;
                }
            }
            // Only follow rightward drag (panel is anchored to right edge)
            if (decided && dx > 0) {
                content.style.transform = 'translateX(' + dx + 'px)';
            }
        }, { passive: true });

        function endDrag() {
            if (!dragging) return;
            dragging = false;
            content.style.transition = '';
            var width = content.offsetWidth || 1;
            var velocity = dx / Math.max(1, Date.now() - startTs);
            if (dx > width * CLOSE_RATIO || velocity > CLOSE_VELOCITY) {
                content.style.transform = '';
                panel.classList.remove('active');
                window.ppDuoTarget = null;
            } else {
                content.style.transform = '';
            }
        }
        content.addEventListener('touchend', endDrag);
        content.addEventListener('touchcancel', endDrag);
    })();

    async function refreshLibrary() {
        // First show IndexedDB cached photos
        try {
            var cached = await idbGetAll();
            renderGrid(cached);
        } catch(e) {}

        // Then fetch from blob and merge
        try {
            var remote = await loadFromBlob();
            if (remote.length > 0) {
                // Merge with local, dedupe by id
                var cached = await idbGetAll();
                var ids = new Set(cached.map(function(p) { return p.id; }));
                for (var i = 0; i < remote.length; i++) {
                    if (!ids.has(remote[i].id)) {
                        remote[i].uploadedAt = new Date(remote[i].uploadedAt).getTime();
                        await idbSave(remote[i]);
                    }
                }
                var all = await idbGetAll();
                renderGrid(all);
            }
        } catch(e) {
            console.error('Failed to load remote photos:', e);
        }
    }

    // Handle file upload from library panel
    document.addEventListener('DOMContentLoaded', function() {
        var fileInput = document.getElementById('ptp-library-file-input');
        if (fileInput) {
            fileInput.addEventListener('change', async function(e) {
                var files = Array.from(e.target.files);
                for (var i = 0; i < files.length; i++) {
                    await handleLibraryUpload(files[i]);
                }
                fileInput.value = '';
            });
        }

        // Show linked email if exists
        if (linkedEmail) {
            var linkDiv = document.getElementById('ptp-library-link');
            var linkedDiv = document.getElementById('ptp-library-linked');
            var emailSpan = document.getElementById('ptp-linked-email');
            if (linkDiv) linkDiv.style.display = 'none';
            if (linkedDiv) linkedDiv.style.display = 'flex';
            if (emailSpan) emailSpan.textContent = linkedEmail;
        }

        // Init IndexedDB
        openDB().catch(function(e) { console.error('IndexedDB error:', e); });

        // Restore last photo on page load
        restoreLastPhoto();
    });

    async function handleLibraryUpload(file) {
        if (file.size > 50 * 1024 * 1024) {
            alert('Image too large (max 50MB)');
            return;
        }

        // HEIC conversion — iOS often reports empty file.type for HEIC, so also
        // detect by extension. Convert to JPEG so non-Safari browsers can preview
        // and so Gemini / downstream upscalers can read the image.
        var name = (file.name || '').toLowerCase();
        var type = file.type || '';
        var isHeic = name.endsWith('.heic') || name.endsWith('.heif') || type === 'image/heic' || type === 'image/heif';
        if (isHeic) {
            if (typeof heic2any === 'undefined') {
                alert('HEIC conversion is not available on this page. Please upload a JPEG or PNG.');
                return;
            }
            try {
                var blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
                if (Array.isArray(blob)) blob = blob[0];
                file = new File([blob], file.name.replace(/\.(heic|heif)$/i, '.jpg'), { type: 'image/jpeg' });
            } catch(e) {
                alert('Could not convert HEIC image. Please try a JPEG or PNG.');
                return;
            }
        }

        // Downscale to 1600px longest edge so the base64 payload stays under
        // Vercel's request body limit on /api/photo-library/upload.
        try {
            file = await downscaleFile(file);
        } catch(e) {
            alert('Could not process image. Please try a different photo.');
            return;
        }

        // Generate thumbnail locally
        var thumbUrl = await generateThumbnail(file, 200);

        // Create a temporary local entry
        var id = 'local-' + Date.now() + '-' + Math.random().toString(36).substr(2, 6);
        var dataUrl = await fileToDataUrl(file);

        var photo = {
            id: id,
            dataUrl: dataUrl,
            thumbUrl: thumbUrl,
            uploadedAt: Date.now(),
            blobUrl: ''
        };

        // Save to IndexedDB immediately
        try {
            await idbSave(photo);
            var all = await idbGetAll();
            renderGrid(all);
        } catch(e) {}

        // Auto-load the just-uploaded photo into the tool slot. Uses dataUrl as
        // an immediate optimistic load so the customer sees their pet right away;
        // the blob URL replaces it once the upload completes (below).
        loadPhotoIntoTool(dataUrl);

        // Upload to Vercel Blob in background
        try {
            var result = await uploadToBlob(file);
            photo.id = result.id;
            photo.blobUrl = result.url;

            // Update IndexedDB with blob URL
            await idbDelete(id); // remove temp
            await idbSave(photo);

            // Save as last used photo
            localStorage.setItem('ptp-last-photo-url', result.url);

            var all = await idbGetAll();
            renderGrid(all);
        } catch(e) {
            console.error('Blob upload failed:', e);
        }
    }

    function generateThumbnail(file, maxSize) {
        return new Promise(function(resolve) {
            var img = new Image();
            img.onload = function() {
                var scale = maxSize / Math.max(img.width, img.height);
                if (scale > 1) scale = 1;
                var c = document.createElement('canvas');
                c.width = Math.round(img.width * scale);
                c.height = Math.round(img.height * scale);
                c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
                resolve(c.toDataURL('image/jpeg', 0.7));
            };
            img.src = URL.createObjectURL(file);
        });
    }

    function fileToDataUrl(file) {
        return new Promise(function(resolve) {
            var reader = new FileReader();
            reader.onload = function() { resolve(reader.result); };
            reader.readAsDataURL(file);
        });
    }

    // Downscale a File to 1600px longest edge JPEG. Returns a new File so the
    // rest of the upload pipeline (uploadToBlob, /api/photo-library/upload)
    // stays under Vercel's request body limit. Original full-res photo is not
    // preserved — fine for our use case, Gemini tokenizes to ~768px tiles.
    function downscaleFile(file, maxEdge, quality) {
        maxEdge = maxEdge || 1600;
        quality = quality || 0.85;
        return new Promise(function(resolve, reject) {
            var img = new Image();
            var url = URL.createObjectURL(file);
            img.onload = function() {
                var w = img.naturalWidth, h = img.naturalHeight;
                var scale = Math.min(1, maxEdge / Math.max(w, h));
                if (scale === 1) { URL.revokeObjectURL(url); resolve(file); return; }
                var c = document.createElement('canvas');
                c.width = Math.round(w * scale);
                c.height = Math.round(h * scale);
                c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
                URL.revokeObjectURL(url);
                c.toBlob(function(blob) {
                    if (!blob) { reject(new Error('Canvas encode failed.')); return; }
                    resolve(new File([blob], (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
                }, 'image/jpeg', quality);
            };
            img.onerror = function() { URL.revokeObjectURL(url); reject(new Error('Failed to load image.')); };
            img.src = url;
        });
    }

    window.ptpDeletePhoto = async function(id, blobUrl) {
        // Delete from IndexedDB
        try { await idbDelete(id); } catch(e) {}

        // Delete from Vercel Blob
        if (blobUrl) {
            try {
                await fetch(API_BASE + '/delete', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ url: blobUrl })
                });
            } catch(e) {}
        }

        // Re-render
        var all = await idbGetAll();
        renderGrid(all);
    };

    window.ptpLinkEmail = async function() {
        var email = document.getElementById('ptp-library-email').value.trim();
        if (!email || !email.includes('@')) {
            alert('Please enter a valid email');
            return;
        }

        try {
            var resp = await fetch(API_BASE + '/link', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ browserId: browserId, email: email })
            });

            if (resp.ok) {
                linkedEmail = email;
                localStorage.setItem('ptp-linked-email', email);

                document.getElementById('ptp-library-link').style.display = 'none';
                document.getElementById('ptp-library-linked').style.display = 'flex';
                document.getElementById('ptp-linked-email').textContent = email;
            }
        } catch(e) {
            console.error('Link email failed:', e);
        }
    };

    // Restore last photo on page load
    async function restoreLastPhoto() {
        try {
            await openDB();
        } catch(e) { return; }
        var photos = await idbGetAll();
        if (photos.length > 0) {
            photos.sort(function(a, b) { return (b.uploadedAt || 0) - (a.uploadedAt || 0); });
            var latest = photos[0];
            // Try blob URL first, then dataUrl
            var url = latest.blobUrl || latest.dataUrl;
            if (url) {
                // Test if URL is loadable
                var testImg = new Image();
                testImg.crossOrigin = 'anonymous';
                testImg.onload = function() {
                    loadPhotoIntoTool(url);
                };
                testImg.onerror = function() {
                    // Blob URL failed, try dataUrl fallback
                    if (latest.dataUrl && latest.dataUrl !== url) {
                        loadPhotoIntoTool(latest.dataUrl);
                    }
                };
                testImg.src = url;
            }
        }
    }

    // Also upload photos via the main upload button to the library
    document.addEventListener('DOMContentLoaded', function() {
        var mainUpload = document.getElementById('ptp-direct-upload');
        if (mainUpload) {
            var origHandler = mainUpload.onchange;
            mainUpload.addEventListener('change', function(e) {
                if (e.target.files.length > 0) {
                    // Save to library in background
                    handleLibraryUpload(e.target.files[0]);
                }
            });
        }
    });
})();
